/**
 * Initializes and returns braintree client using given authorization
 * @param {String} authorization braintree token to authorize client
 * @returns the braintree client or null if there's no authorization
 */
const initBraintreeClient = async (authorization) => {
  if (!authorization) {
    return null;
  }

  const client = await (() =>
    // eslint-disable-next-line import/no-unresolved
    import(/* webpackChunkName: "swi-braintree" */ 'braintree-web/client'))();
  const braintree = await client.create({authorization});

  return braintree;
};

/**
 * Initializes and returns 3D secure client using given braintree client
 * @param {string} braintreeClient braintree client
 * @returns the 3D secure client or null if there's no braintree client
 */
const initBt3DSecureClient = async (braintreeClient) => {
  if (!braintreeClient) {
    return null;
  }

  const client = await (() =>
    import(/* webpackChunkName: "swi-braintree-three-d-secure" */ 'braintree-web/three-d-secure'))();
  const braintree3DSClient = await client.create({
    client: braintreeClient,
    version: 2,
  });

  return braintree3DSClient;
};

export {initBraintreeClient, initBt3DSecureClient};
